export const NAME = 'marketPlace';

export const leadsFinishTypeId = 100;

export const leadTypesIds = {
	birthday: 100,
	nameday: 101,
	contractAnniversary5years: 102,
	contractAnniversary10years: 103,
	clientAnniversary3years: 104,
	clientAnniversary5years: 105,
	clientAnniversary10years: 106,
	leadZP: 107,
	businessOpportunity: 108,
	webLead: 109,
	opportunityLead: 110,
	acquisitionsContacts: 111,
	businessOpportunitySME: 112,
	meetingFromSellerWeb: 188,
	autoPOV: 196,
	autoHAV: 197,
	property: 198,
	pet: 199,
	responsibility: 200,
	traveling: 201,
	autoPOVAndHAV: 203,
	questionFromMyGenerali: 204,
	leadProductPageNZP: 225,
	sportEquipmentInsurance: 236,
	sportEquipmentInsuranceFcb: 237,
	fleetInsurance: 249,
	apartmentBuilding: 253,
	myGeneraliMeeting: 265,
};

export const quickFilter = {
	CURRENT: 'CURRENT',
	FUTURE: 'FUTURE',
	IN_PROGRESS: 'IN_PROGRESS',
	INPROGRESSORAFTERDEADLINE: 'INPROGRESSORAFTERDEADLINE',
};

export const quickFilterTypesSetup = [
	{
		label: 'marketPlace:current',
		type: quickFilter.CURRENT,
	},
	{
		label: 'marketPlace:future',
		type: quickFilter.FUTURE,
	},
	{
		label: 'marketPlace:inProgress',
		type: quickFilter.IN_PROGRESS,
	},
	{
		label: 'marketPlace:inProgressOrAfterDeadline',
		type: quickFilter.INPROGRESSORAFTERDEADLINE,
	},
];

export const feedbackType = {
	IN_DETAIL: 'IN_DETAIL',
	IN_LIST: 'IN_LIST',
};

export const formDataFieldsMap = {
	taskType: 'Název příležitosti',
	taskSubTypeId: 'Podtyp příležitosti',
	firstName: 'Jméno',
	surname: 'Příjmení',
	businessName: 'Název',
	businessIn: 'IČO',
	personIn: 'Rodné číslo',
	municipality: 'Obec',
	zipCode: 'PSČ',
	policyNumber: 'Číslo PS',
	quickFilterCurrent: 'Aktuální',
	quickFilterFuture: 'Budoucí',
	quickFilterInProgress: 'Rozpracováno',
};

export const formDataBeMapper = {
	taskType: 'taskTypeId',
	taskSubTypeId: 'taskSubtypeId',
	firstName: 'clientFirstname',
	surname: 'clientSurname',
	businessName: 'businessName',
	businessIn: 'businessIn',
	personIn: 'clientPersonIn',
	municipality: 'clientCity',
	zipCode: 'clientZipCode',
	policyNumber: 'policyNo',
};

export const dialogs = {
	tooManyResults: `${NAME}/tooManyResults`,
};

export const LEAD_RETURNED_TO_MP_DUE_SLA_TIMEOUT = 998000033;
export const LEAD_ALREADY_TAKEN = 999000031;
export const LEAD_ALREADY_PROCESSED = 999000006;
